import { z } from 'zod';
import superjson from 'superjson';
import { AnnotationItem } from './list_GET.schema';

// Define the structure for annotation data
const PointSchema = z.object({
  x: z.number(),
  y: z.number(),
});

const ShapeSchema = z.object({
  type: z.enum(['rect', 'circle', 'arrow', 'freehand']),
  points: z.array(PointSchema),
  color: z.string(),
  strokeWidth: z.number(),
});

const TextNoteSchema = z.object({
  x: z.number(),
  y: z.number(),
  text: z.string(),
});

const AnnotationDataSchema = z
  .object({
    shapes: z.array(ShapeSchema).optional(),
    textNotes: z.array(TextNoteSchema).optional(),
    // Allow other properties for flexibility
  })
  .passthrough();

export const schema = z.object({
  sessionId: z.string().min(1),
  annotationData: AnnotationDataSchema,
  description: z.string().optional(),
  attachmentId: z.string().optional(),
  checkpointId: z.string().optional(),
});

export type InputType = z.infer<typeof schema>;

export type OutputType = {
  annotation: AnnotationItem;
};

export const createAnnotation = async (
  body: InputType,
  init?: RequestInit,
): Promise<OutputType> => {
  const validatedInput = schema.parse(body);
  const result = await fetch(`/_api/annotations/create`, {
    method: 'POST',
    credentials: 'include',
    body: superjson.stringify(validatedInput),
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });
  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
